/**
 * ============================================================================
 * AUTH STORE - ZUSTAND
 * ============================================================================
 * 
 * Global authentication state management
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      loading: false,

      // Actions
      setAuth: (user, tokens) => {
        const access = tokens?.accessToken || null;
        const refresh = tokens?.refreshToken || null;
        set({
          user,
          accessToken: access,
          refreshToken: refresh,
          isAuthenticated: !!user && !!access,
        });
        if (typeof localStorage !== 'undefined') {
          if (access) localStorage.setItem('accessToken', access);
          if (refresh) localStorage.setItem('refreshToken', refresh);
        }
      },

      setUser: (user) => {
        set({ user });
      },

      setTokens: (tokens) => {
        const refresh = tokens?.refreshToken || null;
        const access = tokens?.accessToken || null;
        set({
          accessToken: access,
          refreshToken: refresh,
          isAuthenticated: !!get().user && !!access,
        });
        if (typeof localStorage !== 'undefined' && refresh) {
          localStorage.setItem('refreshToken', refresh);
        }
        if (typeof localStorage !== 'undefined' && access) {
          localStorage.setItem('accessToken', access);
        }
      },

      logout: () => {
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
        });
        // Also clear localStorage immediately
        if (typeof localStorage !== 'undefined') {
          try {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
          } catch (e) {
            console.error('Error clearing localStorage on logout:', e);
          }
        }
      },

      setLoading: (loading) => {
        set({ loading });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        if (typeof localStorage === 'undefined') return;
        if (state?.accessToken) localStorage.setItem('accessToken', state.accessToken);
        if (state?.refreshToken) localStorage.setItem('refreshToken', state.refreshToken);
      },
    }
  )
);

export default useAuthStore;
